import React from 'react';
import {IconButton} from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {useTranslation} from 'react-i18next';

interface AppTablePaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
}

const AppTablePagination: React.FC<AppTablePaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
}) => {
  const {i18n} = useTranslation();
  const isHebrew = i18n.language === 'heb';

  const handleFirstPageButtonClick = () => {
    onPageChange(0);
  };

  const handleBackButtonClick = () => {
    onPageChange(page - 1);
  };

  const handleNextButtonClick = () => {
    onPageChange(page + 1);
  };

  const handleLastPageButtonClick = () => {
    onPageChange(Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const currentPage = page + 1;

  return (
    <div className="w-full p-3 flex justify-center bg-white z-2 shadow-bottom-sm">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1">
          <p className="m-0 text-sm text-black90">
            {`${page * rowsPerPage + 1} עד ${Math.min(
              (page + 1) * rowsPerPage,
              count,
            )} מתוך ${count}`}
          </p>
        </div>

        <div className="flex flex-row items-center gap-2">
          <IconButton
            onClick={handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="first page"
            sx={{padding: 0}}>
            {isHebrew ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
          <IconButton
            onClick={handleNextButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="previous page"
            sx={{padding: 0}}>
            {isHebrew ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          </IconButton>

          <p className="m-0 text-sm text-black90">
            {`דף ${currentPage} מתוך ${Math.ceil(count / rowsPerPage)}`}
          </p>

          <IconButton
            onClick={handleBackButtonClick}
            disabled={page === 0}
            aria-label="next page"
            sx={{padding: 0}}>
            {isHebrew ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </IconButton>

          <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={page === 0}
            aria-label="last page"
            sx={{padding: 0}}>
            {isHebrew ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton>
        </div>
      </div>
    </div>
  );
};
export default AppTablePagination;
